import { useEffect } from 'react';

var URL = 'https://cdn.jsdelivr.net/gh/AmauriC/tarteaucitron.js@1.9.6/tarteaucitron.min.js';
var CONSENT_SCRIPT_ID = 'tarteaucitron_script_id';

var refresh = function refresh() {
  if (typeof window.tarteaucitron !== 'undefined') {
    var tarteaucitron = window.tarteaucitron;

    if (tarteaucitron.triggerJobsAfterAjaxCall instanceof Function) {
      tarteaucitron.triggerJobsAfterAjaxCall();
    }
  }
};

var ConsentCookies = function ConsentCookies(_ref) {
  var _ref$customText = _ref.customText,
      customText = _ref$customText === void 0 ? {} : _ref$customText,
      _ref$initialize = _ref.initialize,
      initProps = _ref$initialize === void 0 ? {} : _ref$initialize,
      _ref$jobs = _ref.jobs,
      jobs = _ref$jobs === void 0 ? [] : _ref$jobs,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user;

  var onLoad = function onLoad() {
    if (typeof window.tarteaucitron !== 'undefined') {
      var tarteaucitron = window.tarteaucitron; // set custom texts

      window.tarteaucitronCustomText = customText;

      if (typeof tarteaucitron.init !== 'undefined' && tarteaucitron.init instanceof Function) {
        // set user
        tarteaucitron.user = user; // set jobs

        tarteaucitron.job = jobs; // initialize

        tarteaucitron.init(initProps);
      }
    }
  };

  useEffect(function () {
    if (window && document) {
      var isScriptExist = document.getElementById(CONSENT_SCRIPT_ID);

      if (!isScriptExist) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = URL;
        script.id = CONSENT_SCRIPT_ID;
        document.body.appendChild(script);
        script.addEventListener('load', onLoad);
      }
    } //eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return null;
};

export { ConsentCookies as default, refresh };
